/**
 * Extracts the file extension from a URL, ignoring query params and fragments.
 * Returns the matching element from `extensions` (preserving its casing) if the URL's extension matches, otherwise undefined.
 */
export function getUrlFileExtension<T extends string>(url: string | undefined, extensions: T[]): T | undefined {
  if (!url) {
    return undefined;
  }

  try {
    const { pathname } = new URL(url);
    const ext = pathname.split('.').pop()?.toUpperCase();

    return extensions.find((e) => e.toUpperCase() === ext);
  } catch {
    return undefined;
  }
}
